import { gql } from "@apollo/client";

export const FETCH_TAGS = gql`
  query FETCH_TAGS($categoryKey: String) {
    taggingTags(categoryKey: $categoryKey) {
      id
      value
      category {
        id
        name
      }
    }
  }
`;

export const REPLACE_OBJECT_ALL_TAGS = gql`
  mutation ReplaceObjectAllTags(
    $objectId: Int!
    $tagIds: [ID]!
    $contentTypeName: String
    $contentTypeAppLabel: String
    $contentTypeId: ID
  ) {
    taggingReplaceObjectAllTags(
      objectId: $objectId
      tagIds: $tagIds
      contentTypeName: $contentTypeName
      contentTypeAppLabel: $contentTypeAppLabel
      contentTypeId: $contentTypeId
    ) {
      taggedItems {
        id
        objectId
        contentTypeId
        contentTypeAppLabel
        contentTypeModel
        category {
          id
          key
          name
        }
        tag {
          id
          value
          displayName
          label
        }
      }
    }
  }
`;
